$( ->
  $('#new_job .job-post-step-1 #job_country').on 'change', ->
    if $(this).val() == 'AE'
      $('#new_job .job-post-step-1 #job_zip').hide()
    else
      $('#new_job .job-post-step-1 #job_zip').show()
)